import t from './POTemplate.type';
import * as potemplateService from '../../../../services/potemplate.service';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';

export const fetchTableData = (params) => async (dispatch) => {
  try {
    const res = await potemplateService.fetchLandingPageTableData(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PO_TEMPLATE,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchPreviewData = (id) => async (dispatch) => {
  try {
    const res = await potemplateService.fetchPreview(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PREVIEW_DATA,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchEditData = (id) => async (dispatch) => {
  try {
    const res = await potemplateService.fetchPreview(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_EDIT_DATA,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_DATA,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteTableEntery = (id, params, transactionMsg) => async () => {
  try {
    const res = await potemplateService.deleteTableEntery(id, params);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const postPOTemp = (params, transactionMsg) => async () => {
  try {
    const res = await potemplateService.postingPODetails(params);
    if (res?.code === 200) {
      const message = transactionMsg(`PO_TEMPLATE.${res.message}`);
      toasterMsg(message, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updatePOTemp = (params, transactionMsg) => async () => {
  try {
    const res = await potemplateService.updatingPODetails(params);
    if (res?.code === 200) {
      const message = transactionMsg(`PO_TEMPLATE.${res.message}`);
      toasterMsg(message, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const companyUpdate = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.UPDATED_COMP,
      payload: params,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const customUpdate = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.UPDATED_CUSTOM,
      payload: params,
    });
    return params;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const factoryUpdate = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.UPDATED_FACT,
      payload: params,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
